import React from 'react';
import 'partial/OfferManager/modules/CreditFoundation/CreditFoundation.scss';
import SectionContainer from 'components/Containers/SectionContainer';
import PageContainer from 'components/Containers/PageContainer';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import UnifiedCCOffersContainer from 'partial/OfferManager/UnifiedCCOffersContainer';
import { Row } from 'components/Containers/Row/Row';
import { CREDIT_FOUNDATION_ACTION } from 'types/morph.pagePosition.constants';
import TextFromConfig from 'components/TextFromConfig';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';
import { CSPopover } from 'components/Popover/CSPopover';
import { useConfig } from 'hook/config.hook';
import Label from 'components/form/Label/Label';
import OText from 'components/CText/OText';
import MoreWaysToBrowseCard from 'pages/Ocf/components/MoreWaysToBrowseCard';

function Line({ bgColorClass, isFirst }) {
  const className = `goalLineStyle ${bgColorClass} ${
    isFirst ? 'firstLine' : null
  }`.trim();
  return <div className={className} />;
}

function CreditFoundationView(props) {
  const { config } = useConfig();
  const totalLongTermAccounts = 6;
  const accountMix = props.creditInfo.creditScoreAnalysis.accountMix;
  let accounts = accountMix.creditCards + accountMix.homeLoans;
  const defaultTestId = 'CreditFoundationView';
  const outOf6 = Array.from({ length: totalLongTermAccounts }, (e, i) =>
    i > accounts - 1 ? 0 : 1,
  );
  const remainingAccounts = totalLongTermAccounts - accounts;

  const subHeaderText =
    config?.actions?.credit_foundation?.pre_paragraph +
    ' <b>' +
    remainingAccounts +
    '</b> ' +
    config?.actions?.credit_foundation?.post_paragraph;

  return (
    <PageContainer>
      {props.seenPixel}
      {!config?.actions?.credit_foundation?.credit_offers_header && (
        <Disclaimer
          showPartnerText
          datatestid="CreditFoundationView"
          className={'margb8 m-marglr8'}
        />
      )}
      <SectionContainer>
        <div className="creditFoundationContainer">
          <div className="cf-headerAccountSection">
            <div className="cf-headerMessage">
              <div
                className="H3 margB16"
                data-testid={`${defaultTestId}-title`}
              >
                <TextFromConfig
                  path={TextFromConfig.paths.CREDIT_FOUNDATION_HEADER}
                />
              </div>
              <div
                className="message text-16 m-text-14"
                data-testid={`${defaultTestId}-subHeader`}
              >
                <OText text={subHeaderText} />
              </div>

              <div
                className="why"
                data-testid={`${defaultTestId}-whyTooltipSection`}
              >
                <CSPopover
                  placement="bottomLeft"
                  overlayClassName="cfActionPopover"
                  ariaLabel={
                    config?.actions?.credit_foundation?.why_important_tooltip
                  }
                  content={
                    <div
                      data-testid={`${defaultTestId}-whyTooltipContent`}
                      className="advertiser-claimer"
                    >
                      {
                        config?.actions?.credit_foundation
                          ?.why_important_tooltip
                      }
                    </div>
                  }
                >
                  <div
                    data-testid={`${defaultTestId}-whyTooltip`}
                    className="disclaimer"
                  >
                    <TextFromConfig
                      path={TextFromConfig.paths.CREDIT_FOUNDATION_WHYIMPORTANT}
                    />
                  </div>
                </CSPopover>
              </div>
            </div>
            <div className="cf-graphAccounts">
              <div
                className="accountMessage"
                data-testid={`${defaultTestId}-accountMessage`}
              >
                <div
                  data-testid={`${defaultTestId}-numAccounts`}
                  className="accountNumber"
                >
                  {accounts}/{totalLongTermAccounts}
                </div>
                <div
                  data-testid={`${defaultTestId}-longTermAccText`}
                  className="longTermAccountLabel"
                >
                  Long-term accounts
                </div>
              </div>
              <div
                data-testid={`${defaultTestId}-numAccountsGraph`}
                className="accounts"
              >
                {outOf6.map((val, index) => {
                  return (
                    <Line
                      key={index}
                      isFirst={!index}
                      bgColorClass={val ? 'green' : 'gray'}
                    ></Line>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <FlexContainer className={'flex-column'}>
          {config?.actions?.credit_foundation?.credit_offers_header && (
            <Label className="margT32 margB16 padLR48 m-padLR16">
              <Label
                type="H3"
                className="borderBottom1 borderNeutral050 padB8 margB16"
              >
                <TextFromConfig
                  path={
                    TextFromConfig.paths.CREDIT_FOUNDATION_CREDIT_OFFERS_HEADER
                  }
                />
              </Label>
              <Disclaimer
                showPartnerText
                datatestid="CreditFoundationView"
                className={'margb8 m-marglr8'}
              />
            </Label>
          )}
          <UnifiedCCOffersContainer
            {...props}
            datatestid={defaultTestId}
            pagePosition={CREDIT_FOUNDATION_ACTION}
            showSeeMoreCardsLink={false}
          />
        </FlexContainer>
      </SectionContainer>
      <Row />
    </PageContainer>
  );
}

export default CreditFoundationView;
